import React from "react";

import "./Panel.css";

const Panel = props => (
  <div style={props.style || {}} className={"realaccess-panel"}>
    {props.children}
  </div>
);
export default Panel;



// WEBPACK FOOTER //
// ./src/common/components/Panel/index.js